module.exports = __webpack_public_path__ + "img/hb-active.20ae52ed.png";